import WFSRequest from './WFSRequest';
import GeometrySerializerUtil from './GeometrySerializer';

export default class HeatDataController {
  /**
     * Geoserver service configuration
     */
  serviceConfig = null;

  /**
   * Open Layers map.
   */
  map = null;

  /**
   * Construction of the controller.
   * @param {ol.Map} map OpenLayers map
   * @param {Object} serviceConfig Configuration properties of the controller.
   */
  constructor (map, serviceConfig) {
    this.map = map;
    this.serviceConfig = serviceConfig;
  }

  /**
   * Request the heat data to buildings for the currently selected
   * scenario and area.
   * @param {String} lid The LID of the layer.
   * @param {ol.geom.Geometry} area The geometry of the selected area.
   * @param {axios.CancelTokenSource} cancelTokenSrc An optional cancel token to abort the request.
   */
  requestAreaData (area, cancelTokenSrc) {
    const me = this;

    const activeLayer = me.map.getLayers().getArray().find(
      layer => layer.get('visible') === true &&
        layer.get('isBaseLayer') !== true &&
        layer.get('additive') !== true
    );

    const lid = `'${activeLayer.get('lid')}'`;

    return new Promise((resolve, reject) => {
      // Serialize the geometry as WKT, prefixed by 'SRID=xxxx;'.
      const viewProj = me.map.getView().getProjection();
      const wkt = GeometrySerializerUtil.serializePostgisWKT(
        area, viewProj, me.serviceConfig.projection);

      // Send the request
      WFSRequest.send(me.serviceConfig.baseUrl + '/ows', {
        featureTypes: ['sql_aggregation_freeform'],
        outputFormat: 'application/json',
        viewParams: {
          target_tbl: lid,
          in_geom: wkt
        }
      }, null, cancelTokenSrc)
        .then(function (response) {
          const features = response.data.features;
          resolve(me.processFeatures(features));
        })
        .catch(function (error) {
          reject(error);
        });
    });
  };

  /**
   * Postprocess WFS response to return an ordered array of heat data.
   * @param {ol.feature[]} features
   */
  processFeatures (features) {
    if (!features) {
      // console.log('no processFeatures');
      return [];
    }
    return features
      .map(feat => {
        const p = feat.properties;
        return {
          param: p.param,
          scenario: p.scenario,
          year_group: p.year_group,
          totalSum: p.total_sum
        };
      });
  }
}
